import BaseApi from './BaseApi'

export default class Filter extends BaseApi {
  rate () {
    return this.axios.get('/catalog/filter/rate')
  }

  common () {
    return this.axios.get('/catalog/filter/common')
  }

  static () {
    return this.axios.get('/catalog/filter/static')
  }

  table () {
    return this.axios.get('/catalog/filter/table-filter')
  }
}
